import React from 'react';

// Components
import { PythonDoc } from "components/api";

export function ConfigTemplate({ children }){
  return <PythonDoc.Content name={"pyhectiqlab.ConfigTemplate"}>
          {children}
          </PythonDoc.Content>
}

export function ConfigTemplateHelp(){
  return <div>
          <PythonDoc.Head prefix="@classmethod" name="ConfigTemplate.help" description="Print in a json format the description to initialize the object." params={[]}/>
         </div>
}

export function ConfigTemplateToConfig(){
  const params = [
  {name: "store_description", type: "bool", default: "False", description:"Set to true to store the parameters description into `__help__`"}]
  return <div>
          <PythonDoc.Head prefix="@classmethod" name="ConfigTemplate.to_config" description="Initialize a configuration object with the attributes of the objet. Returns a Config. " params={params}/>
          <PythonDoc.Params params={params}/>
         </div>
}
